import Vue from 'vue'

import firebase from "firebase";

const state = {
  projectSlots: [],
  survey: {}, 
  posts: []
};

const actions = {
  bindAnything({ commit, state }, {id, collection, then, reference} ) {
    if( !id ){
      return;
    }
    if( !state[reference] ){
      return;
    }    
    let exists = state[reference].find( a => a.id == id );
    if( !exists ){    
      firebase.firestore().collection(collection).doc(id).onSnapshot(snapshot => {
          commit(then, { id: snapshot.id, data: snapshot.data(), reference: reference });
      });
      return true;
    }
    return false;
  },
  fetchSlots({commit}, id){
    firebase.firestore().doc( "projectSlots/" + id ).onSnapshot( (doc) => {
      let slots = doc.data();
      slots.id = doc.id;
      commit("SET_ONETHING",{ ref: "projectSlots", data: slots})
    })
  },
  fetchSurvey({commit}, id){
    firebase.firestore().doc( "surveys/" + id ).onSnapshot( (doc) => {
      let survey = doc.data();
      survey.id = doc.id; 
      commit("SET_ONETHING", {ref: "survey", data: survey} )
    })
  },
  fetchPost({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "posts", then: "SET_ANYTHING", reference: "posts" } )
  },
};

const mutations = {
  SET_ONETHING(state, {ref, data}){
    Vue.set( state, ref, data );
  },
  SET_ANYTHING(state, {id, data, reference}) {
    if( !id ){ return; }
    if( typeof data == 'undefined') { return; }
    if( !state[reference] ) { return; }
    let index = state[reference].length;
    data.id = id;
    let exists = state[reference].find( p => p.id == id );
    if( exists ){
      index = state[reference].indexOf( exists )
    }
    Vue.set( state[reference], index, data );
  }

};

export default {
  state,
  actions,
  mutations,
};
